import { array, mixed, number, object, string } from 'yup';
import { EarmarkValueDTO } from '../../../../api/useWhatIfGroupsQuery';

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Sales: {
    AssetId: string | null;
    SaleYear: string | null;
    NetProceedsFromSale: {
      YearsAfterSaleYear: number;
      SaleAmount: number | null;
      NetWorthPercent: number | null;
    }[];
    Earmarks: EarmarkValueDTO[];
    DoNotSell: boolean;
  }[];
}

export const FORM_SCHEMA = object({
  Sales: array(
    object({
      AssetId: string()
        .typeError('Select the business asset.')
        .required('Select the business asset.'),
      SaleYear: mixed().when('DoNotSell', {
        is: false,
        then: number()
          .typeError('Select the year this asset will be sold.')
          .nullable(),
      }),
      NetProceedsFromSale: array(
        mixed().when('DoNotSell', {
          is: false,
          then: object({
            SaleAmount: number().typeError('Required'),
            NetWorthPercent: number()
              .typeError('Required')
              .max(100, 'Must be less than or equal than 100%'),
          }),
        }),
      ),
    }).test('unique-asset', 'You cannot sell the same asset twice.', (asset, ctx) => {
      if (ctx.parent.filter(({ AssetId }) => AssetId === asset.AssetId).length > 1) {
        throw ctx.createError({ path: `${ctx.path}.AssetId` });
      }

      return true;
    }),
  ),
});

export const DEFAULT_NET_PROCEEDS = {
  SaleAmount: null,
  NetWorthPercent: null,
};

export const DEFAULT_SALE = {
  AssetId: null,
  SaleYear: '',
  NetProceedsFromSale: [{ YearsAfterSaleYear: 1, ...DEFAULT_NET_PROCEEDS }],
  Earmarks: [],
  DoNotSell: false,
};

export const DEFAULT_VALUES: FormValues = {
  Sales: [DEFAULT_SALE],
  WhatIfKey: '1000',
  WhatIfType: 1000,
  WhatIfTypeName: 'BusinessSale',
};
